import { render, staticRenderFns } from "./exercises-test-exercises.vue?vue&type=template&id=1c6d376e"
import script from "./exercises-test-exercises.vue?vue&type=script&lang=js"
export * from "./exercises-test-exercises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports